var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryAnotherBehalf = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h49.265v49.153H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.864 22.545c2.633 0 4.756-2.14 4.756-4.772 0-2.633-2.123-4.773-4.756-4.773a4.777 4.777 0 0 0-4.773 4.773 4.777 4.777 0 0 0 4.773 4.772zm-12.728 0c2.633 0 4.757-2.14 4.757-4.772 0-2.633-2.124-4.773-4.757-4.773a4.777 4.777 0 0 0-4.772 4.773 4.777 4.777 0 0 0 4.772 4.772zm0 3.182C15.422 25.727 8 27.59 8 31.295v3.978h22.273v-3.978c0-3.706-7.422-5.568-11.137-5.568zm12.728 0c-.462 0-.979.032-1.536.088 1.846 1.328 3.127 3.118 3.127 5.48v3.978H43v-3.978c0-3.706-7.422-5.568-11.136-5.568z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryAnotherBehalf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-another-behalf.0803554929ba1a69cb90eed5bdde5c7e.svg";